import { render, staticRenderFns } from "./oldItemReturnDialog.vue?vue&type=template&id=5b7f032e&scoped=true"
import script from "./oldItemReturnDialog.vue?vue&type=script&lang=js"
export * from "./oldItemReturnDialog.vue?vue&type=script&lang=js"
import style0 from "./oldItemReturnDialog.vue?vue&type=style&index=0&id=5b7f032e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7f032e",
  null
  
)

export default component.exports